import Lookup from 'src/componentes/select-async';
import DicionarioRiscoSearchComponent from './SearchComponent/DicionarioRiscoSearchComponent';


const DicionarioRiscoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/DicionarioRiscoLookup"
    showSearch
    searchComponent={DicionarioRiscoSearchComponent}
    {...rest}
  />
);

export default DicionarioRiscoLookup;
